/* eslint-disable @typescript-eslint/naming-convention */
import { createTheme } from '@mui/material/styles';

declare module '@mui/material/styles' {
  interface Theme {
    logo: string;
  }

  interface ThemeOptions {
    logo?: string;
  }
}

const theme = createTheme({
  palette: {
    primary: {
      main: '#0cc2aa',
    },
    secondary: {
      main: '#5d5e6a',
    },
    background: {
      default: '#f1f7f7',
      paper: '#ffffff',
    },
    text: {
      primary: '#444',
      secondary: '#444',
    },
  },
  logo: 'https://assets.streamgo.vc/logos/streamGo-logo-final.png',
});

export default theme;
